// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.league-team-upload-image__header {
    display: flex;
    align-items: center;
    padding: var(--space);
    background: var(--white-color);
    box-shadow: var(--shadow-card-2);
}
.league-team-upload-image__action {
  display: flex;
  align-items: center;
  justify-content: center;
}
.league-team-upload-image__action__button {
   mix-blend-mode: normal;
   border: 2px solid #00E063;
   box-sizing: border-box;
   border-radius: 2px;
   width: 400px;
}
p.league-team-upload-image__header__title {
    margin-right: var(--space);
    color: var(--primary-dark-color) !important;
}
.league-team-upload-image__header__button {
    margin-right: var(--space-half);
}
.league-team-upload-image__content {
    max-height: 550px;
    position: relative;
}
.league-team-upload-image__content__media {
    position: relative;
    height: 400px;
    width: 100%;
}
.league-team-upload-image__content__media img {
    height: 100%;
}
.league-team-upload-image__content__result {
    position: relative;
    height: 400px;
    width: 100%;
    display: flex;
    justify-content: center;
}
.league-team-upload-image__content__result__container {
    position: relative;
    height: 100%;
}
.league-team-upload-image__content__result__container__loader {
    position: absolute;
    left: 0;
    right: 0;
    top:180px;
    bottom: 0;
    margin-right: auto;
    margin-right: auto;
    margin-top: auto;
    margin-bottom: auto;
    width: 400px;
}

.league-team-upload-image__content__result img {
    height: 100%;
}

.league-team-upload-image__form {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: var(--space-and-half);
}
.league-team-upload-image__form input {
    width: 100%;
}
.league-team-upload-image__form__form {
    display: flex;
    flex-direction: column;
}
.league-team-upload-image__form__field {
    margin: 0 !important;
}
.league-team-upload-image__form__field input {
    margin: 0;
}
.league-team-upload-image__form__group {
    display: flex;
    justify-content: flex-end;
}
.league-team-upload-image__form__submit {
    margin-top: var(--space-and-half);
    align-self: flex-end;
    margin-left: var(--space);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 
    .league-team-upload-image__content__result img {
        max-height: 400px;
        max-width: 380px;
        height: auto;
        width: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-team-upload-image-modal/LeagueTeamUploadImageModalComponent.styles.css"],"names":[],"mappings":";;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,8BAA8B;IAC9B,gCAAgC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;GACG,sBAAsB;GACtB,yBAAyB;GACzB,sBAAsB;GACtB,kBAAkB;GAClB,YAAY;AACf;AACA;IACI,0BAA0B;IAC1B,2CAA2C;AAC/C;AACA;IACI,+BAA+B;AACnC;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,8BAA8B;AAClC;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,iCAAiC;IACjC,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,WAAW;IACf;AACJ","sourcesContent":["\n\n.league-team-upload-image__header {\n    display: flex;\n    align-items: center;\n    padding: var(--space);\n    background: var(--white-color);\n    box-shadow: var(--shadow-card-2);\n}\n.league-team-upload-image__action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.league-team-upload-image__action__button {\n   mix-blend-mode: normal;\n   border: 2px solid #00E063;\n   box-sizing: border-box;\n   border-radius: 2px;\n   width: 400px;\n}\np.league-team-upload-image__header__title {\n    margin-right: var(--space);\n    color: var(--primary-dark-color) !important;\n}\n.league-team-upload-image__header__button {\n    margin-right: var(--space-half);\n}\n.league-team-upload-image__content {\n    max-height: 550px;\n    position: relative;\n}\n.league-team-upload-image__content__media {\n    position: relative;\n    height: 400px;\n    width: 100%;\n}\n.league-team-upload-image__content__media img {\n    height: 100%;\n}\n.league-team-upload-image__content__result {\n    position: relative;\n    height: 400px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n.league-team-upload-image__content__result__container {\n    position: relative;\n    height: 100%;\n}\n.league-team-upload-image__content__result__container__loader {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top:180px;\n    bottom: 0;\n    margin-right: auto;\n    margin-right: auto;\n    margin-top: auto;\n    margin-bottom: auto;\n    width: 400px;\n}\n\n.league-team-upload-image__content__result img {\n    height: 100%;\n}\n\n.league-team-upload-image__form {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    padding: var(--space-and-half);\n}\n.league-team-upload-image__form input {\n    width: 100%;\n}\n.league-team-upload-image__form__form {\n    display: flex;\n    flex-direction: column;\n}\n.league-team-upload-image__form__field {\n    margin: 0 !important;\n}\n.league-team-upload-image__form__field input {\n    margin: 0;\n}\n.league-team-upload-image__form__group {\n    display: flex;\n    justify-content: flex-end;\n}\n.league-team-upload-image__form__submit {\n    margin-top: var(--space-and-half);\n    align-self: flex-end;\n    margin-left: var(--space);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n    .league-team-upload-image__content__result img {\n        max-height: 400px;\n        max-width: 380px;\n        height: auto;\n        width: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
